import TWEEN from '@tweenjs/tween.js';
import * as THREE from 'three';
let moveTween, rotateTween, scaleTween;

export function UpdateCamera(cam, int, controls){
    const time = 2000;
    let _frameCount = 1;

    
    const animate = ()=>{

      if(int < 0 || _frameCount >=  cam.userData.cameraDatum[int]?.length)
        return;
      
      if(moveTween != undefined){
        moveTween.stop();
      }
      if(rotateTween != undefined){
        rotateTween.stop();
      }

  let  _newPos = cam.userData.cameraDatum[int]?.[_frameCount]?.cameraPosition;
  let  _newRot = cam.userData.cameraDatum[int]?.[_frameCount]?.cameraRotation;

  if(_newPos == undefined){
    _newPos = cam.position;
  }
  if(_newRot == undefined){
    _newRot = cam.rotation;
  }
  controls.enabled = false;

  //console.log('_frameCount: ', _frameCount,cam.userData.cameraDatum[int]?.[_frameCount],_newPos,_newRot);
  const vector = new THREE.Vector3().setFromEuler(_newRot);
  rotateTween = new TWEEN.Tween(cam.rotation).to(vector,time)
  rotateTween.start();
  
  
   moveTween = new TWEEN.Tween(cam.position).to(_newPos,time) .onUpdate(() => {
    //controls.update(); 
  }).onComplete(()=>{
    cam.position.copy(_newPos);
    _frameCount++;
    controls.enabled = true;
    animate();
   });
   moveTween.start();

  }
  animate();

}

  